import { Spin, SpinProps } from 'antd'
import React, { FC } from 'react'
import { useResizeDetector } from 'react-resize-detector'
import { styled } from 'styled-components'

/**
 * Ant-D is great... except for when it comes to sizing children by the height of their components relatively (i.e. using %).
 * This Component creates a Spin component that is sized by a % of the parent (default 100%).
 */
export const RelativeHeightSpin: FC<
  SpinProps & { heightPercentOverride?: number }
> = ({ children, heightPercentOverride, ...props }) => {
  const heightPercent = heightPercentOverride ?? 100

  const { ref, height } = useResizeDetector()
  return (
    <RelativeSizedDiv ref={ref} $heightPercent={heightPercent}>
      <StyledSpin {...props}>
        <AbsoluteSizedDiv $height={height}>{children}</AbsoluteSizedDiv>
      </StyledSpin>
    </RelativeSizedDiv>
  )
}

/**
 * Get the relative height to the calling parent div
 */
const RelativeSizedDiv = styled.div<{
  $heightPercent: number
}>`
  height: ${({ $heightPercent }) => $heightPercent}%;
`

/**
 * Create a Spin, where the spin icon is centered vertically (by overriding the default max-height of 400px)
 */
const StyledSpin = styled(Spin)`
  max-height: 100% !important;
`

/**
 * A div container for the children, sized to the RelativeSizedDiv
 */
const AbsoluteSizedDiv = styled.div<{
  $height: number | undefined
}>`
  ${({ $height }) => {
    if ($height === undefined) {
      return ''
    } else {
      return `height: ${$height}px;`
    }
  }}
`
